// src/utils/ledgerKinds.js
// D-289 Step 0b — what KIND of money a financial_transactions row is.
//
// WHY THIS EXISTS: the ledger holds two kinds of expense rows.
//   SPEND rows — money the company paid or owes outside the business
//     (vendor payable at GRN, expense request, transport, subcontractor
//     bill, manual entry). These make up the company's total expense.
//   ALLOCATION rows — cost of something ALREADY bought, charged to a
//     project when it is used (material issued from store, equipment
//     issued/returned, Direct Site Purchase project cost). They feed
//     project costing (project_summary / Costing Card) only.
// Adding both into one company total counts the same rupee twice (e.g. a
// vendor payable at GRN + the material issue of that same stock). Any
// company-wide total must skip allocation rows; any project-level total
// must include them.
//
// Detection uses fields old rows already have, so no migration is needed:
//   material issue          → reference_type "material_issue"       (inventoryService.js)
//   equipment issue/return  → category "equipment"                  (equipmentService.js)
//   direct site purchase    → reference_type "direct_site_purchase" (directSitePurchaseService.js)
// Any NEW allocation-type flow must be added here in the same change.

const ALLOCATION_REFERENCE_TYPES = ["material_issue", "direct_site_purchase"];

export const isProjectAllocation = (row) =>
  !!row &&
  row.type === "expense" &&
  (ALLOCATION_REFERENCE_TYPES.includes(row.reference_type) ||
   row.category === "equipment");